import { useState, useEffect, useCallback } from 'react';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';
import { IAsyncToken, IPromiseFunction } from './types';

/**
 * a custom Hook that will return an auto-canceled async token Creator
 * @param {function} promiseFunc - a function that will return a Promise when it's called
 *  with any args
 * @returns {function} a safe async token creator that will be auto-canceled after a new
 * promise is created or before the Hook wrapper is unmounted
 */
export const useCreateSafeAsyncToken = <TArgs extends any[], TResult>(promiseFunc: IPromiseFunction<TArgs, TResult>): ((...args: TArgs) => IAsyncToken<TResult>) => {
  const [token, setToken] = useState<IAsyncToken<TResult> | null>(null);

  useEffect(() => () => token && token.cancel(), [token]);

  return useCallback((...args: TArgs): IAsyncToken<TResult> => {
    const asyncToken = createAsyncToken(promiseFunc(...args)) as unknown as IAsyncToken<TResult>;

    setToken(asyncToken);

    return asyncToken;
  }, [promiseFunc]);
};
